import type { Artifact, DiagramType } from "../engine/types";

export interface CoverTheme {
  background: string;
  accent: string;
  secondary: string;
  ink: string;
  variant: number;
  rotation: number;
  density: number;
  glyph: string;
}

const PALETTES = [
  ["#10233f", "#7bded0", "#ffd166", "#fffaf0"],
  ["#341f47", "#ff7a8a", "#8ff0dd", "#fff8eb"],
  ["#0b4f55", "#ffd166", "#f49ac2", "#f7fffb"],
  ["#26345f", "#b8ff70", "#ff8f70", "#fffaf0"],
  ["#4a2344", "#78e0d0", "#ffca65", "#fff7fd"],
  ["#123b5d", "#f39ac7", "#8cf0c7", "#fffbed"],
] as const;

const GLYPHS: Record<DiagramType, string> = {
  flowchart: "◇→□",
  mindmap: "✦⌁✦",
  sequence: "◎↝◎",
  state: "◌⇄◉",
  class: "▤＋▤",
  timeline: "●—●—●",
};

function seedFor(artifact: Pick<Artifact, "contentHash" | "title" | "tags" | "mermaidSource">): number {
  const source = artifact.contentHash || `${artifact.title}|${artifact.tags.join("|")}|${artifact.mermaidSource ?? ""}`;
  let seed = 2166136261;
  for (const character of source) seed = Math.imul(seed ^ character.charCodeAt(0), 16777619) >>> 0;
  return seed;
}

export function coverThemeForArtifact(artifact: Pick<Artifact, "contentHash" | "title" | "tags" | "mermaidSource" | "diagramType">): CoverTheme {
  const seed = seedFor(artifact);
  const palette = PALETTES[seed % PALETTES.length]!;
  const sourceLines = artifact.mermaidSource?.split("\n").filter((line) => line.trim()).length ?? 1;
  return {
    background: palette[0],
    accent: palette[1],
    secondary: palette[2],
    ink: palette[3],
    variant: (seed >>> 5) % 4,
    rotation: ((seed >>> 9) % 25) - 12,
    density: Math.max(3, Math.min(9, Math.round(Math.sqrt(sourceLines)))),
    glyph: GLYPHS[artifact.diagramType ?? "flowchart"],
  };
}

